import * as React from 'react';

import { INewbuildingSectionProps } from '../../../common/utils/types';
import { useSelector } from 'react-redux';
import { selectFormFields, selectNewbuildingName } from '../../selectors';
import { useActions } from '../useActions';
import { ECurrentErrorField } from '../../types/formFields';
import { trackNewbuildingSectionSelect } from '../tracking';

export const useNewbuildingSectionProps = (): INewbuildingSectionProps => {
  const newbuildingName = useSelector(selectNewbuildingName);
  const { newbuildingSection, newbuildingSectionsList, errorTooltip } = useSelector(selectFormFields);

  const { setNewbuildingSection } = useActions();

  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.section ? errorTooltip.errorText : '';

  const onItemChange = React.useCallback<INewbuildingSectionProps['onItemChange']>(
    value => {
      setNewbuildingSection(value);

      /**
       * Список корпусов и поиск внутри него по id (которое value) на этом этапе
       * точно возможен, так как сюда попадаем при выборе корпуса из списка
       */
      // oxlint-disable-next-line typescript/no-non-null-assertion
      const sectionName = newbuildingSectionsList!.find(section => section.value === value)!.label;
      trackNewbuildingSectionSelect(sectionName);
    },
    [newbuildingSectionsList, setNewbuildingSection],
  );

  return {
    newbuildingName,
    selectedSection: newbuildingSection,
    newbuildingSections: newbuildingSectionsList ?? [],
    onItemChange,
    errorMessage,
  };
};
